// src/components/utils.js

/**
 * Given javaVersions: [ { version, date, features: [{ id, metadata: { feature_name, ... } }] } … ],
 * returns a map: base feature name -> array of { name, phase, version, date }
 */
export function extractFeatureRecords(javaVersions) {
  const map = {};

  javaVersions.forEach(({ version, date, features }) => {
    features.forEach(({ metadata: { feature_name } }) => {
      // Detect phase from a trailing "(Preview)" or "(Incubator)"
      let phase = 'Final';
      if (/\(Preview\)$/i.test(feature_name)) {
        phase = 'Preview';
      } else if (/\(Incubator\)$/i.test(feature_name)) {
        phase = 'Incubator';
      }

      // Strip that suffix to get the base feature name
      const name = feature_name.replace(/\s*\((Preview|Incubator)\)$/i, '').trim();

      if (!map[name]) {
        map[name] = [];
      }
      map[name].push({ name, phase, version, date });
    });
  });

  // Sort each feature’s history by ascending date
  Object.values(map).forEach(records => {
    records.sort((a, b) => new Date(a.date) - new Date(b.date));
  });

  return map;
}

export default extractFeatureRecords;